import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class I2gLayoutService {
  constructor(@Inject(DOCUMENT) private _document: Document) {}

  public disableBodyScrolling() {
    this._document.body.style.overflow = 'hidden';
  }

  public enableBodyScrolling() {
    this._document.body.style.overflow = null;
  }
}
